import axiosClient from '../../configs/axios';


class UserMasterService {
    // Get list 
    async getUserList(params) {
        try {
            const response = await axiosClient.get(
                `/user/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }


 async getresetpasswordList(params) {
  try {
    const response = await axiosClient.post('/user/reset-password', {
      username: params.username,
      user_id: params.user_id,
      new_password: params.newPassword,  
    });
    return response.data;
  } catch (error) {
    throw error;
  }

 }

    async getUserRoleList(params) {
        try {
            const response = await axiosClient.get(
                `/user/role?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addUser(data) {
        try {
            const response = await axiosClient.post('/user/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteUser(data) {
        try {
            const response = await axiosClient.put(`/user/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new UserMasterService(); 